import React, {Component} from 'react';
import styled from 'styled-components';
import HomeWindow from "../home/HomeWindow";
import Translation from "../dictionary/Translation";
import Button from "../common/Button";
import Row from "../catalog/Row";
import Pagination from "../catalog/Pagination";
import Main from "../layout/Main";
import Nav from "../layout/Nav";
import PageHeader from "../home/PageHeader";
import ScrollToTopOnMount from "../common/ScrollToTopOnMount";
import {bindActionCreators} from "redux";
import * as Actions from "../../actions/actions";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";

class Catalog extends Component {

    componentWillMount() {
        this.props.requestProducts();
    }

    render() {
        return (
            <React.Fragment>
                <ScrollToTopOnMount/>
                <Nav/>
                <PageHeader title={<Translation k={'CATALOG_HEADER'}/>}
                            //subtitle={<Translation k={'CATALOG_SUBHEADER'}/>}
                            actions={
                                <Button fixedMin onClick={() => console.log('click')}
                                        label={<Translation k={'DOWNLOAD_PRICELIST'}/>}/>
                            }/>
                <Main>
                    <Row/>
                    <Pagination/>
                </Main>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestProducts: Actions.requestProducts
    }, dispatch)
}

export default connect(null, mapDispatchToProps)(toJS(Catalog));